// extracted by mini-css-extract-plugin
module.exports = {"acknowledgements":"styles_acknowledgements__OZ2Mg","logos":"styles_logos__13uA4","text":"styles_text__XqQIQ"};